module.exports = __webpack_public_path__ + "img/2_2.464236fa.png";